import { configApiRef, useApi } from '@backstage/core-plugin-api';
import { usePageTitle } from '../../hooks';

type PageProps = {
  title: string;
  children: React.ReactNode;
  appTitlePrefix?: boolean; // default: false => "Page | App", true => "App | Page"
};

export const Page = (props: PageProps) => {
  const { title, children, appTitlePrefix = false } = props;

  const config = useApi(configApiRef);

  const appTitleFromConfig =
    config.getOptionalString('app.title') ?? 'Backstage';
  const appTitle = appTitlePrefix
    ? [appTitleFromConfig, title].filter(Boolean).join(' | ')
    : [title, appTitleFromConfig].filter(Boolean).join(' | ');

  usePageTitle(appTitle);

  return <>{children}</>;
};
